import GetData from '../helpers/GetData'

export default class Order {
    constructor(data, callback) {
        new GetData({
            endpoint: 'build-order',
            ajax_overrides: {
                method: 'POST',
                data: {
                    order: {
                        paypal_id: data.paypal?.id,
                        user_uuid: window.current_user?.uuid,
                        total: data.cart.total.raw,
                        items: data.cart.items,
                        email: data.paypal?.payer.email_address,
                        first_name: data.paypal?.payer.name.given_name,
                        last_name: data.paypal?.payer.name.surname,
                        address_line_1: data.paypal?.purchase_units[0]?.shipping.address.address_line_1,
                        address_line_2: data.paypal?.purchase_units[0]?.shipping.address.address_line_2,
                        city: data.paypal?.purchase_units[0]?.shipping.address.admin_area_2,
                        state: data.paypal?.purchase_units[0]?.shipping.address.admin_area_1,
                        zip: data.paypal?.purchase_units[0]?.shipping.address.postal_code,
                        country: data.paypal?.purchase_units[0]?.shipping.address.country_code
                    }
                }
            },
            callback: (data) => {
                if(callback) {
                    callback(data);
                }
            }
        });
    }
}
